import './../assets/css/poli/index.css';
import './../assets/css/newIdentity/newPoli.css';

export default function PoliTheme() {
  return <></>;
}
